import React, { useState, useEffect  } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import * as IconlyPack from "react-iconly";
import UsersSkeleton from "../../../Tables/backend/Users/UsersSkeleton";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import UserDetails from "../../../Tables/backend/Users/modalUser/UserDetails";
import { fetchUsers } from "../../../../redux/users/usersAction";
import Swal from "sweetalert2";
import Axios from "axios";
import api from "../../../../Http/global-vars";
import entrepreneur from "../../../../services/entrepreneur";

const EntrepreneurTable = (props) => {
  const config = {
    headers: {
      Authorization: `Bearer  ${sessionStorage.getItem("userToken")}`,
    },
  };

  const users = useSelector((state) => state.users);
  //filtre
  const [valeurFiltre, setValeurFiltre] = useState("");
  const [entrepreneursState, setEntrepreneursState] = useState([]);
  const handleChangementFiltre = (e) => {
    setValeurFiltre(e.target.value);
  };
//   const incubateursFiltres = users.data && Array.isArray(users?.data)
//   ? users.data.filter((incubateur) => {
//       const nomComplet =
//         incubateur?.prenom + " " + incubateur?.nom + " " + incubateur?.email + " " + incubateur?.user_type + " " + incubateur?.phone;
//         return nomComplet.toLowerCase().includes(valeurFiltre.toLowerCase()) && incubateur.user_type === "entrepreneur";
//       })
//   : [];
// console.log({entrepreneursState});
  const dispatch = useDispatch();

  const options = {
    clearSearch: false,
    noDataText: "Aucune donnée disponible",
  };
  const current_user = useSelector((state) => state.user).data;
  const id=current_user?.id
// fgger
useEffect(() => {
  // Appel à onGetListUsers lors du montage initial du composant
  onGetListUsers();
}, [current_user]); // Déclencher l'effet une seule fois après le montage initial

const onGetListUsers = async () => {
  try {
    if (current_user.isLoading) {
      return [{ label: "Loading...", value: "" }];
    } else {
    const entrepreneurs = await entrepreneur.getEntrepreneur(config);
    console.log({entrepreneurs});
    const filteredEntrepreneurs = entrepreneurs?.results?.filter(
      (entrepreneur) => entrepreneur?.incubateur === id
    );
    console.log({filteredEntrepreneurs});
    setEntrepreneursState(
      filteredEntrepreneurs.sort(
        (a, b) => new Date(b.date_joined) - new Date(a.date_joined)
      )
    );
  }
  } catch (error) {
    console.log(error);
  }
};
console.log();
  const onDelete = (item) => {
    let token = window.sessionStorage.getItem("userToken");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    Swal.fire({
      title: `Êtes vous sûr de vouloir ${
        item?.is_active ? "désactiver" : "activer"
      } cet utilisateur?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Valider",
      cancelButtonText: "Annuler",
      showLoaderOnConfirm: true,
      confirmButtonColor: "var(--secondary-color)",
      cancelButtonColor: "#E53E3E",
      preConfirm: () => {
        return Axios.put(
          `${api}user/${item?.id}/`,
          { is_active: !item?.is_active },
          config
        )
          .then(async (response) => {
            console.log("res", response);
            await dispatch(fetchUsers());
            return response;
          })
          .catch((error) => {
            console.log(error);
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("res", result);
        Swal.fire({
          icon: "success",
          title: `Utilisateur ${
            item?.is_active ? "désactivé" : "activé"
          } avec succès.`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  const nameFormatter = (cell, row) => {
    return (
      <div className="name-email-group">
        <span className="name">{row.prenom + " " + row?.nom}</span>
        <span className="email">{cell}</span>
      </div>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <div className="table-actions-container">
        <button
          data-bs-toggle="modal"
          data-bs-target={"#DetailsUserModal" + row.id}
          style={{ color: "#9B51E0", backgroundColor: "transparent" }}
          className="mr-2"
        >
          <IconlyPack.Show />
        </button>
       

        <div
          className="modal fade in"
          id={"DetailsUserModal" + row.id}
          tabIndex="-1"
          aria-labelledby="CreerDateLancementLabel"
          aria-hidden="true"
        >
           <UserDetails user={row} />
        </div>
        {/* <div
          className="modal fade in"
          id={`EditUserModal${row?.id}`}
          tabIndex="-1"
          aria-labelledby="EditUserModalLabel"
          aria-hidden="true"
        >
         <UserEditModal user={row} /> 
        </div> */}
      </div>
    );
  };

  return (
    <div className="child-table-container">
      <div className="table-body-container-activite">
        {/* Filtres */}
        <div className="filtres-container pb-4">
          <h6 className="filter-label">Filter</h6>
          <div className="filter-input-group">
            <input
              type="text"
              className="filter-input"
              placeholder="Rechercher..."
              value={valeurFiltre}
              onChange={handleChangementFiltre}
            />
          </div>
        </div>
        <div className="row easypm-table-row">
          <div className="col-md-12 easypm-table-col">
          {entrepreneursState.length === 0 && <UsersSkeleton />}
           {entrepreneursState.length > 0 && (
              <div className="table-container-activite">
                <BootstrapTable
                  data={entrepreneursState}
                  hover={true}
                  condensed={true}
                  multiColumnSort={2}
                  options={options}
                  version="4"
                  pagination
                  bordered={false}
                >
                  <TableHeaderColumn
                    isKey={true}
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 12,
                      color: "#A0AEC0",
                      fontFamily: "Poppins",
                    }}
                    tdStyle={{
                      fontWeight: "normal",
                      fontSize: 14,
                      color: "#2d3748",
                      fontFamily: "Poppins",
                      zIndex: 0,
                      position: "static"
                    }}
                    width="150"
                    dataField="email"
                    dataFormat={(cell, row) => nameFormatter(cell, row)}
                  >
                    Noms + Email
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 12,
                      color: "#A0AEC0",
                      fontFamily: "Poppins",
                    }}
                    tdStyle={{
                      fontWeight: "normal",
                      fontSize: 14,
                      color: "#2d3748",
                      fontFamily: "Poppins",
                      zIndex: 0,
                      position: "static"
                    }}
                    width="100"
                    dataField="phone"
                  >
                    Téléphone
                  </TableHeaderColumn>
                   <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 12,
                      color: "#A0AEC0",
                      fontFamily: "Poppins",
                    }}
                    tdStyle={{
                      fontWeight: "normal",
                      fontSize: 14,
                      color: "#2d3748",
                      fontFamily: "Poppins",
                      zIndex: 0,
                      position: "static"
                    }}
                    width="100"
                    dataField="user_type"
                  >
                    Profil
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 12,
                      color: "#A0AEC0",
                      fontFamily: "Poppins",
                    }}
                    tdStyle={{
                      fontWeight: "normal",
                      fontSize: 14,
                      color: "#2d3748",
                      fontFamily: "Poppins",
                      zIndex: 0,
                      position: "static"
                    }}
                    width="100"
                    dataField="created_at"
                    dataFormat={(cell, row) =>
                      moment(cell).format("DD/MM/YYYY")
                    }
                  >
                    Date d'inscription
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 12,
                      color: "#A0AEC0",
                      fontFamily: "Poppins",
                    }}
                    dataField="id"
                    width="100"
                    dataFormat={(cell, row) => actionFormatter(cell, row)}
                  >
                    Actions
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntrepreneurTable;
